export const yvCountries = [
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "dz",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "bw",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "bf",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "cm",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "cd",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "eg",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "sz",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "gh",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ci",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "jo",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ke",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "kw",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ly",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "mu",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ma",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "mz",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ly",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ng",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "om",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "rw",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "sn",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "za",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "sd",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "tz",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "tn",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "ug",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "zw",
  },
  {
      //pass country code you want the document to be capture for. (optional)
      countryCode: "us",
  },
]

export const africanCountries = [
  { Country: 'Algeria', YvCode: 'dz' },
  { Country: 'Angola', YvCode: 'ao' },
  { Country: 'Benin', YvCode: 'bj' },
  { Country: 'Botswana', YvCode: 'bw' },
  { Country: 'Burkina Faso', YvCode: 'bf' },
  { Country: 'Burundi', YvCode: 'bi' },
  { Country: 'Cabo Verde', YvCode: 'cv' },
  { Country: 'Cameroon', YvCode: 'cm' },
  { Country: 'Central African Republic', YvCode: 'cf' },
  { Country: 'Chad', YvCode: 'td' },
  { Country: 'Comoros', YvCode: 'km' },
  { Country: 'Congo (Brazzaville)', YvCode: 'cg' },
  { Country: 'Congo (Kinshasa)', YvCode: 'cd' },
  { Country: 'Djibouti', YvCode: 'dj' },
  { Country: 'Egypt', YvCode: 'eg' },
  { Country: 'Equatorial Guinea', YvCode: 'gq' },
  { Country: 'Eritrea', YvCode: 'er' },
  { Country: 'Eswatini', YvCode: 'sz' },
  { Country: 'Ethiopia', YvCode: 'et' },
  { Country: 'Gabon', YvCode: 'ga' },
  { Country: 'The Gambia', YvCode: 'gm' },
  { Country: 'Ghana', YvCode: 'gh' },
  { Country: 'Guinea', YvCode: 'gn' },
  { Country: 'Guinea-Bissau', YvCode: 'gw' },
  { Country: 'Ivory Coast', YvCode: 'ci' },
  { Country: 'Kenya', YvCode: 'ke' },
  { Country: 'Lesotho', YvCode: 'ls' },
  { Country: 'Liberia', YvCode: 'lr' },
  { Country: 'Libya', YvCode: 'ly' },
  { Country: 'Madagascar', YvCode: 'mg' },
  { Country: 'Malawi', YvCode: 'mw' },
  { Country: 'Mali', YvCode: 'ml' },
  { Country: 'Mauritania', YvCode: 'mr' },
  { Country: 'Mauritius', YvCode: 'mu' },
  { Country: 'Morocco', YvCode: 'ma' },
  { Country: 'Mozambique', YvCode: 'mz' },
  { Country: 'Namibia', YvCode: 'na' },
  { Country: 'Niger', YvCode: 'ne' },
  { Country: 'Nigeria', YvCode: 'ng' },
  { Country: 'Rwanda', YvCode: 'rw' },
  { Country: 'São Tomé and Príncipe', YvCode: 'st' },
  { Country: 'Senegal', YvCode: 'sn' },
  { Country: 'Seychelles', YvCode: 'sc' },
  { Country: 'Sierra Leone', YvCode: 'sl' },
  { Country: 'Somalia', YvCode: 'so' },
  { Country: 'South Africa', YvCode: 'za' },
  { Country: 'South Sudan', YvCode: 'ss' },
  { Country: 'Sudan', YvCode: 'sd' },
  { Country: 'Tanzania', YvCode: 'tz' },
  { Country: 'Togo', YvCode: 'tg' },
  { Country: 'Tunisia', YvCode: 'tn' },
  { Country: 'Uganda', YvCode: 'ug' },
  { Country: 'Zambia', YvCode: 'zm' },
  { Country: 'Zimbabwe', YvCode: 'zw' }
];

export const verifiableCountries = africanCountries.filter( ac => yvCountries.some( yv => yv.countryCode === ac.YvCode))
export const isVerifiable = (code: string) => (yvCountries.some( yv => yv.countryCode === code));

export const allCountries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo (Brazzaville)',
  'Congo (Kinshasa)',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini (Swaziland)',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar (Burma)',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'North Korea',
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'São Tomé and Príncipe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Vatican City',
  'Venezuela',
  'Vietnam',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

export const phoneFormats = [
  { label: 'Afghanistan', value: '+93 ### #######' },
  { label: 'Albania', value: '+355 ### #######' },
  { label: 'Algeria', value: '+213 ### #######' },
  { label: 'Andorra', value: '+376 ### #######' },
  { label: 'Angola', value: '+244 ### #######' },
  { label: 'Antigua and Barbuda', value: '+1-268 ### ####' },
  { label: 'Argentina', value: '+54 ### #######' },
  { label: 'Armenia', value: '+374 ### #######' },
  { label: 'Australia', value: '+61 ### #######' },
  { label: 'Austria', value: '+43 ### #######' },
  { label: 'Azerbaijan', value: '+994 ### #######' },
  { label: 'Bahamas', value: '+1-242 ### ####' },
  { label: 'Bahrain', value: '+973 ### #######' },
  { label: 'Bangladesh', value: '+880 ### #######' },
  { label: 'Barbados', value: '+1-246 ### ####' },
  { label: 'Belarus', value: '+375 ### #######' },
  { label: 'Belgium', value: '+32 ### #######' },
  { label: 'Belize', value: '+501 ### ####' },
  { label: 'Benin', value: '+229 ### #######' },
  { label: 'Bhutan', value: '+975 ### #######' },
  { label: 'Bolivia', value: '+591 ### #######' },
  { label: 'Bosnia and Herzegovina', value: '+387 ### #######' },
  { label: 'Botswana', value: '+267 ### #######' },
  { label: 'Brazil', value: '+55 ### #######' },
  { label: 'Brunei', value: '+673 ### ####' },
  { label: 'Bulgaria', value: '+359 ### #######' },
  { label: 'Burkina Faso', value: '+226 ### #######' },
  { label: 'Burundi', value: '+257 ### #######' },
  { label: 'Cabo Verde', value: '+238 ### #######' },
  { label: 'Cambodia', value: '+855 ### #######' },
  { label: 'Cameroon', value: '+237 ### #######' },
  { label: 'Canada', value: '+1 ### ### ####' },
  { label: 'Central African Republic', value: '+236 ### #######' },
  { label: 'Chad', value: '+235 ### #######' },
  { label: 'Chile', value: '+56 ### #######' },
  { label: 'China', value: '+86 ### #######' },
  { label: 'Colombia', value: '+57 ### #######' },
  { label: 'Comoros', value: '+269 ### #######' },
  { label: 'Congo (Brazzaville)', value: '+242 ### #######' },
  { label: 'Congo (Kinshasa)', value: '+243 ### #######' },
  { label: 'Costa Rica', value: '+506 ### ####' },
  { label: 'Croatia', value: '+385 ### #######' },
  { label: 'Cuba', value: '+53 ### #######' },
  { label: 'Cyprus', value: '+357 ### #######' },
  { label: 'Czech Republic', value: '+420 ### #######' },
  { label: 'Denmark', value: '+45 ### #######' },
  { label: 'Djibouti', value: '+253 ### #######' },
  { label: 'Dominica', value: '+1-767 ### ####' },
  { label: 'Dominican Republic', value: '+1-809 ### ####' },
  { label: 'Ecuador', value: '+593 ### #######' },
  { label: 'Egypt', value: '+20 ### #######' },
  { label: 'El Salvador', value: '+503 ### ####' },
  { label: 'Equatorial Guinea', value: '+240 ### #######' },
  { label: 'Eritrea', value: '+291 ### #######' },
  { label: 'Estonia', value: '+372 ### #######' },
  { label: 'Eswatini (Swaziland)', value: '+268 ### #######' },
  { label: 'Ethiopia', value: '+251 ### #######' },
  { label: 'Fiji', value: '+679 ### ####' },
  { label: 'Finland', value: '+358 ### #######' },
  { label: 'France', value: '+33 ### #######' },
  { label: 'Gabon', value: '+241 ### #######' },
  { label: 'The Gambia', value: '+220 ### #######' },
  { label: 'Georgia', value: '+995 ### #######' },
  { label: 'Germany', value: '+49 ### #######' },
  { label: 'Ghana', value: '+233 ### #######' },
  { label: 'Greece', value: '+30 ### #######' },
  { label: 'Grenada', value: '+1-473 ### ####' },
  { label: 'Guatemala', value: '+502 ### ####' },
  { label: 'Guinea', value: '+224 ### #######' },
  { label: 'Guinea-Bissau', value: '+245 ### #######' },
  { label: 'Guyana', value: '+592 ### ####' },
  { label: 'Haiti', value: '+509 ### ####' },
  { label: 'Honduras', value: '+504 ### ####' },
  { label: 'Hungary', value: '+36 ### #######' },
  { label: 'Iceland', value: '+354 ### ####' },
  { label: 'India', value: '+91 ### #######' },
  { label: 'Indonesia', value: '+62 ### #######' },
  { label: 'Iran', value: '+98 ### #######' },
  { label: 'Iraq', value: '+964 ### #######' },
  { label: 'Ireland', value: '+353 ### #######' },
  { label: 'Israel', value: '+972 ### #######' },
  { label: 'Italy', value: '+39 ### #######' },
  { label: 'Ivory Coast', value: '+225 ### #######' },
  { label: 'Jamaica', value: '+1-876 ### ####' },
  { label: 'Japan', value: '+81 ### #######' },
  { label: 'Jordan', value: '+962 ### #######' },
  { label: 'Kazakhstan', value: '+7 ### #######' },
  { label: 'Kenya', value: '+254 ### #######' },
  { label: 'Kiribati', value: '+686 ### ####' },
  { label: 'Kuwait', value: '+965 ### #######' },
  { label: 'Kyrgyzstan', value: '+996 ### #######' },
  { label: 'Laos', value: '+856 ### #######' },
  { label: 'Latvia', value: '+371 ### #######' },
  { label: 'Lebanon', value: '+961 ### #######' },
  { label: 'Lesotho', value: '+266 ### #######' },
  { label: 'Liberia', value: '+231 ### #######' },
  { label: 'Libya', value: '+218 ### #######' },
  { label: 'Liechtenstein', value: '+423 ### #######' },
  { label: 'Lithuania', value: '+370 ### #######' },
  { label: 'Luxembourg', value: '+352 ### #######' },
  { label: 'Madagascar', value: '+261 ### #######' },
  { label: 'Malawi', value: '+265 ### #######' },
  { label: 'Malaysia', value: '+60 ### #######' },
  { label: 'Maldives', value: '+960 ### ####' },
  { label: 'Mali', value: '+223 ### #######' },
  { label: 'Malta', value: '+356 ### #######' },
  { label: 'Marshall Islands', value: '+692 ### ####' },
  { label: 'Mauritania', value: '+222 ### #######' },
  { label: 'Mauritius', value: '+230 ### #######' },
  { label: 'Mexico', value: '+52 ### #######' },
  { label: 'Micronesia', value: '+691 ### ####' },
  { label: 'Moldova', value: '+373 ### #######' },
  { label: 'Monaco', value: '+377 ### #######' },
  { label: 'Mongolia', value: '+976 ### #######' },
  { label: 'Montenegro', value: '+382 ### #######' },
  { label: 'Morocco', value: '+212 ### #######' },
  { label: 'Mozambique', value: '+258 ### #######' },
  { label: 'Myanmar (Burma)', value: '+95 ### #######' },
  { label: 'Namibia', value: '+264 ### #######' },
  { label: 'Nauru', value: '+674 ### ####' },
  { label: 'Nepal', value: '+977 ### #######' },
  { label: 'Netherlands', value: '+31 ### #######' },
  { label: 'New Zealand', value: '+64 ### #######' },
  { label: 'Nicaragua', value: '+505 ### ####' },
  { label: 'Niger', value: '+227 ### #######' },
  { label: 'Nigeria', value: '+234 ### #######' },
  { label: 'North Korea', value: '+850 ### #######' },
  { label: 'North Macedonia', value: '+389 ### #######' },
  { label: 'Norway', value: '+47 ### #######' },
  { label: 'Oman', value: '+968 ### #######' },
  { label: 'Pakistan', value: '+92 ### #######' },
  { label: 'Palau', value: '+680 ### ####' },
  { label: 'Palestine', value: '+970 ### #######' },
  { label: 'Panama', value: '+507 ### ####' },
  { label: 'Papua New Guinea', value: '+675 ### ####' },
  { label: 'Paraguay', value: '+595 ### #######' },
  { label: 'Peru', value: '+51 ### #######' },
  { label: 'Philippines', value: '+63 ### #######' },
  { label: 'Poland', value: '+48 ### #######' },
  { label: 'Portugal', value: '+351 ### #######' },
  { label: 'Qatar', value: '+974 ### #######' },
  { label: 'Romania', value: '+40 ### #######' },
  { label: 'Russia', value: '+7 ### #######' },
  { label: 'Rwanda', value: '+250 ### #######' },
  { label: 'Saint Kitts and Nevis', value: '+1-869 ### ####' },
  { label: 'Saint Lucia', value: '+1-758 ### ####' },
  { label: 'Saint Vincent and the Grenadines', value: '+1-784 ### ####' },
  { label: 'Samoa', value: '+685 ### ####' },
  { label: 'San Marino', value: '+378 ### #######' },
  { label: 'São Tomé and Príncipe', value: '+239 ### #######' },
  { label: 'Saudi Arabia', value: '+966 ### #######' },
  { label: 'Senegal', value: '+221 ### #######' },
  { label: 'Serbia', value: '+381 ### #######' },
  { label: 'Seychelles', value: '+248 ### #######' },
  { label: 'Sierra Leone', value: '+232 ### #######' },
  { label: 'Singapore', value: '+65 ### ####' },
  { label: 'Slovakia', value: '+421 ### #######' },
  { label: 'Slovenia', value: '+386 ### #######' },
  { label: 'Solomon Islands', value: '+677 ### ####' },
  { label: 'Somalia', value: '+252 ### #######' },
  { label: 'South Africa', value: '+27 ### #######' },
  { label: 'South Korea', value: '+82 ### #######' },
  { label: 'South Sudan', value: '+211 ### #######' },
  { label: 'Spain', value: '+34 ### #######' },
  { label: 'Sri Lanka', value: '+94 ### #######' },
  { label: 'Sudan', value: '+249 ### #######' },
  { label: 'Suriname', value: '+597 ### ####' },
  { label: 'Sweden', value: '+46 ### #######' },
  { label: 'Switzerland', value: '+41 ### #######' },
  { label: 'Syria', value: '+963 ### #######' },
  { label: 'Taiwan', value: '+886 ### #######' },
  { label: 'Tajikistan', value: '+992 ### #######' },
  { label: 'Tanzania', value: '+255 ### #######' },
  { label: 'Thailand', value: '+66 ### #######' },
  { label: 'Timor-Leste', value: '+670 ### ####' },
  { label: 'Togo', value: '+228 ### #######' },
  { label: 'Tonga', value: '+676 ### ####' },
  { label: 'Trinidad and Tobago', value: '+1-868 ### ####' },
  { label: 'Tunisia', value: '+216 ### #######' },
  { label: 'Turkey', value: '+90 ### #######' },
  { label: 'Turkmenistan', value: '+993 ### #######' },
  { label: 'Tuvalu', value: '+688 ### ####' },
  { label: 'Uganda', value: '+256 ### #######' },
  { label: 'Ukraine', value: '+380 ### #######' },
  { label: 'United Arab Emirates', value: '+971 ### #######' },
  { label: 'United Kingdom', value: '+44 ### #######' },
  { label: 'United States', value: '+1 ### ### ####' },
  { label: 'Uruguay', value: '+598 ### #######' },
  { label: 'Uzbekistan', value: '+998 ### #######' },
  { label: 'Vanuatu', value: '+678 ### ####' },
  { label: 'Vatican City', value: '+39 ### #######' },
  { label: 'Venezuela', value: '+58 ### #######' },
  { label: 'Vietnam', value: '+84 ### #######' },
  { label: 'Yemen', value: '+967 ### #######' },
  { label: 'Zambia', value: '+260 ### #######' },
  { label: 'Zimbabwe', value: '+263 ### #######' }
];

export const languages = [
  "Arabic",
  "Danish",
  "Dutch",
  "English",
  "Finnish",
  "French",
  "German",
  "Hindi",
  "Indonesian",
  "Italian",
  "Japanese",
  "Korean",
  "Mandarin Chinese",
  "Norwegian",
  "Polish",
  "Portuguese",
  "Russian",
  "Spanish",
  "Swahili",
  "Swedish",
  "Thai",
  "Turkish",
  "Vietnamese"
]

export const Industry = [
  "Technology",
  "Healthcare",
  "Education",
  "Finance",
  "Retail",
  "Manufacturing",
  "Hospitality",
  "Transportation",
  "Real Estate",
  "Media and Entertainment",
  "Agriculture",
  "Construction",
  "Energy",
  "Automotive",
  "Telecommunications",
  "Food and Beverage",
  "Fashion and Apparel",
  "Pharmaceuticals",
  "Non-profit and Social Services",
  "Government and Public Sector",
  "Other"
];

export const TalentSpecializations = [
    {
        label: "Customer Support", 
        roles: [
            "Customer Support Specialist",
            "Executive Assistant",
            "Virtual Assistant",
            "Admin Assistant",
            "Customer Service Manager",
            "Customer Experience Manager",
            "IT Help Desk Analyst",
            "Technical Support Specialist",
            "Translator"
        ],
        filters: [
            "Communication Skills (Verbal & Written)",
            "Active Listening",
            "Problem-Solving",
            "Empathy & Emotional Intelligence",
            "Conflict Resolution",
            "Multi-Channel Support (Phone, Email, Chat, Social Media)",
            "Technical Troubleshooting",
            "SLA & Ticket Management",
            "Upselling & Cross-Selling",
            "Time Management",
            "Customer Feedback Analysis",
            "Zendesk",
            "Salesforce",
            "Freshdesk",
            "HubSpot CRM",
            "Jira Service Management",
            "ServiceNow",
            "Intercom",
            "Drift",
            "LiveChat",
            "Five9",
            "Aircall",
            "Talkdesk",
            "Confluence",
            "Notion",
            "Guru",
            "SurveyMonkey",
            "Typeform",
            "Qualtrics"
        ]
    },
    {
        label: "Design & Creative", 
        roles: [            
            "Videographer",
            "Content Producer",
            "Photographer",
            "Graphic Designer",
            "Animator",
            "Illustrator",
            "Copywriter",
            "Content Writer",
            "Scriptwriter",
            "Blogger",
            "Video Editor",
            "Motion Graphics Designer",
            "Cinematographer",
            "Sound Designer",
            "Visual Effects (VFX) Artist",
            "Colorist",
            "Sound Engineer",
            "Podcast Producer",
            "Voiceover Artist",
            "Audio Editor",
            "Sound Mixer",
            "Creative Director",
            "Art Director",
            "UX/UI Designer",
            "Brand Designer",
            "Camera Operator",
            "Apparel Graphics Designer",
            "Publication Designer",
            "Creative Designer",
            "Social Media Content Creator",
            "UX Architect",
            "Infographic Designer",
            "Multimedia Designer",
            "Design Consultant",
            "Design Director",
            "Data Visualization Specialist",
            "Digital Editor",
            "Design Architect"
        ],
        filters: [
            "UI/UX Design",
            "Wireframing & Prototyping",
            "Branding & Visual Identity",
            "Typography & Color Theory",
            "Motion Graphics & Animation",
            "Illustration & Digital Art",
            "Print & Packaging Design",
            "Copywriting & Content Creation",
            "Photography & Photo Editing",
            "Storyboarding & Concept Development",
            "Adobe Photoshop",
            "Adobe Illustrator",
            "CorelDRAW",
            "Figma",
            "Sketch",
            "Adobe XD",
            "Adobe After Effects",
            "Premiere Pro",
            "Final Cut Pro",
            "DaVinci Resolve",
            "Blender",
            "Maya",
            "Cinema 4D",
            "Procreate",
            "Clip Studio Paint",
            "InDesign",
            "Canva",
            "Lightroom",
            "Capture One",
            "Storyboard That",
            "Toon Boom"
        ]
    },
    {
        label: "Product & Program Management", 
        roles: [
            "Consulting & Customer Support",
            "Design & Creative",
            "Product & Program Management",
            "Engineering & Development",
            "Operations",
            "Data & Research",
            "Project Manager"
        ],
        filters: [
            "Agile & Scrum Methodologies",
            "Product Roadmap Development",
            "User Story Writing & Prioritization",
            "Market Research & Competitive Analysis",
            "Data-Driven Decision Making",
            "Stakeholder Management",
            "Customer Feedback & Iteration",
            "A/B Testing & Experimentation",
            "Risk Assessment & Mitigation",
            "Product Lifecycle Management",
            "Jira",
            "Trello",
            "Asana",
            "Monday.com",
            "ClickUp",
            "Jira Agile",
            "Azure DevOps",
            "Rally",
            "Productboard",
            "Aha!",
            "Roadmunk",
            "Google Analytics",
            "Hotjar",
            "Mixpanel",
            "UserTesting",
            "FullStory",
            "Crazy Egg",
            "Optimizely",
            "Google Optimize",
            "VWO",
            "Typeform",
            "SurveyMonkey",
            "NPS Tools"
        ]
    },
    {
        label: "Engineering & Technology", 
        roles: [
            "Software Engineer",
            "Web Developer",
            "Mobile App Developer",
            "Systems Analyst",
            "Database Administrator",
            "Network Engineer",
            "DevOps Engineer",
            "Front-end Developer",
            "Back-end Developer",
            "Full-stack Developer",
            "Cloud Solutions Architect",
            "UI Engineer",
            "Embedded Systems Engineer",
            "Angular Developer",
            "Flutter Developer",
            "React Native Developer",
            "PHP Developer",
            "Ruby on Rails Developer",
            "Kotlin Developer",
            "Lead Software Engineer",
            "Cybersecurity Analyst",
            "Systems Administrator",
            "Network Security Engineer",
            "Cloud Architect",
            "API Developer",
            "Blockchain Engineer",
            "Game Developer",
            "Golang Engineer",
            "Javascript Developer",
            "Python Developer",
            "React Developer",
            "Rust Developer",
            "Security Engineer",
            "Solutions Architect",
            "SQL Developer",
            "Web3 Developer",
            "WordPress Developer",
            "AI Engineer",
            "AI Researcher",
            "AI Writer",
            "GPT Specialist",
            "ML Engineer",
            "Prompt Engineer",
            "Quantum Machine Learning Engineer",
            "Edge Computing Specialist",
            "Virtual Reality (VR) Developer",
            "Augmented Reality (AR) Developer",
            "Internet of Things (IoT) Specialist",
            "Robotic Process Automation (RPA) Developer",
            "Microsoft 365 Developer",
            "Power Platform Developer",
            "Dynamics 365 Consultant",
            "Microsoft Teams Developer",
            "Microsoft SharePoint Developer",
            "Microsoft Exchange Administrator",
            "Microsoft SQL Server Database Administrator",
            "Microsoft Power Platform Consultant",
            "Microsoft Dynamics 365 Developer",
            "Microsoft Cloud Infrastructure Engineer",
            "Microsoft Endpoint Manager Engineer",
            "Microsoft Azure DevOps Engineer",
            "Data Engineer",
            "Data Scientist",
            "Machine Learning Engineer",
            "Natural Language Processing Engineer",
            "Computer Vision Specialist",
            "Robotics Engineer",
            "Salesforce Specialist",
            "Microsoft Certified Trainer",
            "Civil Engineer",
            "Mechanical Engineer",
            "Electrical Engineer"
        ],
        filters: [
            "Software Development",
            "Frontend Development",
            "Backend Development",
            "Cloud Computing",
            "DevOps & CI/CD",
            "Cybersecurity & Network Security",
            "AI & Machine Learning",
            "API Development & Integration",
            "System Architecture & Scalability",
            "Software Testing & QA",
            "Mobile Development",
            "JavaScript",
            "Python",
            "Java",
            "C#",
            "C++",
            "Go",
            "Ruby",
            "PHP",
            "React",
            "Angular",
            "Vue.js",
            "Svelte",
            "Node.js",
            "Django",
            "Flask",
            ".NET",
            "Spring Boot",
            "Express.js",
            "PostgreSQL",
            "MySQL",
            "MongoDB",
            "Redis",
            "Firebase",
            "AWS",
            "Azure",
            "Google Cloud Platform",
            "Docker",
            "Kubernetes",
            "Jenkins",
            "GitHub Actions",
            "CircleCI",
            "OWASP ZAP",
            "Nessus",
            "Burp Suite",
            "TensorFlow",
            "PyTorch",
            "Scikit-learn",
            "Postman",
            "Swagger",
            "GraphQL",
            "Git",
            "GitHub",
            "GitLab",
            "Bitbucket",
            "Flutter",
            "Swift",
            "Kotlin",
            "React Native"
        ]
    },
    {
        label: "Operations", 
        roles: [
            "Operations Manager",
            "Risk Manager",
            "Strategic Manager",
            "Payroll Manager",
            "Instructional Designer",
            "Training and Development Specialist",
            "E-learning Specialist",
            "Human Resource Manager",
            "Recruiter",
            "Business Systems Analyst",
            "Business Development Representative",
            "Business/Functional Manager",
            "Talent Acquisition Specialist",
            "Tourism Coordinator"
        ],
        filters: [
            "Supply Chain Management",
            "Process Improvement",
            "Inventory & Logistics Management",
            "Vendor & Supplier Negotiation",
            "Procurement & Purchasing",
            "Business Process Automation",
            "Compliance & Risk Management",
            "Cost Reduction Strategies",
            "SAP",
            "Oracle NetSuite",
            "Microsoft Dynamics 365",
            "ShipBob",
            "TradeGecko",
            "Zoho Inventory",
            "Zapier",
            "UiPath",
            "Power Automate",
            "RiskWatch",
            "Resolver",
            "Hyperproof",
            "Tableau",
            "Power BI",
            "Google Data Studio"
        ]
    },
    {
        label: "Data & Research", 
        roles: [
            "Data Scientist",
            "Marketing Analyst",
            "Market Research Analyst",
            "Research Ethics Specialist",
            "Research Assistant",
            "Field Research Coordinator",
            "Survey Designer",
            "Web Data Specialist",
            "Data Analyst",
            "Business Intelligence Analyst",
            "Quantitative Analyst",
            "Marketing Analytics Specialist",
            "Financial Data Analyst",
            "Test Analyst",
            "Junior Business Analyst",
            "Senior Business Analyst",
            "Business Intelligence Specialist",
            "Data Transcriber",
            "Data Translator",
            "Business Development Analyst",
            "IT Business Analyst",
            "Technical Business Analyst",
            "Business Intelligence Analyst",
            "Digital Business Analyst",
            "Data Visualization Specialist",
            "Infographic Designer",
            "Data Journalist",
            "Technical Writer",
            "Research Scientist",
            "Research Fellow",
            "Clinical Research Coordinator",
            "Data Policy Analyst",
            "Data Monetization Specialist",
            "Data Entry Specialist",
            "Information Architect",
            "Data Governance Specialist",
            "Econometrics Specialist",
            "Web Analytics Manager",
            "Conversion Rate Optimization (CRO) Specialist",
            "Retention Marketing Specialist",
            "Marketing Data Analyst",
            "Data Privacy Officer"
        ],
        filters: [
            "Data Analysis",
            "Data Visualization",
            "Statistical Analysis & Hypothesis Testing",
            "Machine Learning & AI Models",
            "Business Intelligence & Reporting",
            "Data Engineering",
            "Predictive Analytics",
            "Market Research & Consumer Insights",
            "Python",
            "R",
            "SQL",
            "Excel",
            "Pandas",
            "Tableau",
            "Power BI",
            "Matplotlib",
            "Seaborn",
            "Looker",
            "Google Data Studio",
            "Mode Analytics",
            "TensorFlow",
            "PyTorch",
            "Scikit-learn",
            "Apache Airflow",
            "Talend",
            "Qualtrics",
            "Typeform",
            "Google Forms"
        ]
    },
    {
        label: "Marketing & Communications", 
        roles: [
            "Social Media Manager",
            "Communication Specialist",
            "Email Marketer",
            "SEO Specialist",
            "Marketing Manager",
            "Community Manager",
            "Influencer Marketer",
            "Affiliate Marketing Manager",
            "Event Marketing Manager",
            "Demand Generation Manager",
            "Growth Marketing Manager",
            "Campaign Manager",
            "Marketing Coordinator",
            "Public Relations Writer",
            "Website Content Writer",
            "Digital Marketing Director",
            "Digital Marketing Consultant",
            "Digital Marketing Analyst",
            "SEO Executive",
            "Social Media Executive",
            "Social Media Specialist",
            "Social Media Assistant",
            "Marketing Director",
            "Growth Marketer",
            "Brand Manager",
            "E-commerce Marketing Manager",
            "SEO Content Specialist",
            "SEM Specialist",
            "Pay-Per-Click (PPC) Manager",
            "Link Building Specialist",
            "SEO Analyst",
            "Social Media Coordinator",
            "Digital Advertising Specialist",
            "Pay-Per-Click (PPC) Specialist",
            "Programmatic Advertising Manager",
            "Media Buyer",
            "Performance Marketing Manager",
            "CRM Specialist",
            "Lifecycle Marketing Specialist",
            "Lead Nurturing Specialist",
            "Online Reputation Manager",
            "Digital Events Coordinator",
            "Webinar Specialist",
            "Communications Manager",
            "PR Manager",
            "Media Relations Specialist",
            "Corporate Communications Manager",
            "Crisis Communication Specialist",
            "Sales Representative",
            "Marketing & Communications",
        ],
        filters: [
            "Content Marketing & Copywriting",
            "SEO & SEM",
            "Social Media Strategy",
            "Email Marketing",
            "Branding & Positioning",
            "Public Relations",
            "Influencer & Partnership Marketing",
            "Web & Conversion Rate Optimization (CRO)",
            "Marketing Automation",
            "Google Ads",
            "Ahrefs",
            "Moz",
            "SEMrush",
            "Hootsuite",
            "Sprout Social",
            "Buffer",
            "Later",
            "Mailchimp",
            "HubSpot",
            "Klaviyo",
            "ActiveCampaign",
            "Marketo",
            "Pardot",
            "Eloqua",
            "Google Analytics",
            "GA4",
            "Mixpanel",
            "Canva",
            "Adobe Spark",
            "Photoshop",
            "Adobe Premiere Pro",
            "Final Cut Pro"
        ]
    }
]

export interface LoginRequest {
  user_login: string | number | undefined;
  password: string | undefined;
}

export enum ProfileType {
  'Talent',
  'Client',
  'Admin'
}

export enum Language {
  'English',
  'French'
}

export enum TalentProfileCreationSteps {
  'Parsing',
  'Personal',
  'Expertise',
  'Education',
  'Experience',
  'Certifications',
  'Portfolio',
  'Preferences',
  'Photo'
}

export const KaziRoles = {
    Admin: 'admin',
    Talent: 'talent',
    Client: 'client'
}

export interface FallbackEmailRequest { 
    locator: string | undefined | null;
    errorId: string;
    error: string;
}

export const VerificationStatus = {
    unverified: 'unverified',
    pending: 'pending',
    denied: 'denied',
    verified: 'verified'
}
export type VerificationStatusType =  keyof typeof VerificationStatus;

export const WebSocketMessageType = {
    VerificationUpdate: 'verification_update',
    Notification: 'notification'
}

export const NodeEvironments = {
    Production: 'production',
    Development: 'development',
    Stage: 'stage'
}
